import { Component } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="error-boundary">
        <div className="max-w-md text-center bg-zinc-900 border border-zinc-800 p-8">
          <AlertTriangle className="h-10 w-10 text-orange-500 mx-auto mb-4" />
          <h2 className="font-heading text-2xl text-white mb-2">Something went wrong</h2>
          <p className="text-zinc-400 mb-6">This page hit a problem. Your data is safe — please try again.</p>
          <Button
            onClick={() => this.setState({ hasError: false })}
            className="bg-orange-600 hover:bg-orange-500"
            data-testid="error-boundary-retry-btn"
          >
            Try again
          </Button>
        </div>
      </div>
    );
  }
}
